export default __webpack_public_path__ + "885fb73fa5c866f5d76ed0d971889483.png";